module.exports = __webpack_public_path__ + "static/media/premioMensal.2d1e183d.png";